import PropTypes from "prop-types";

import MDBox from "components/atoms/MDBox";

function BackgroundDesign({ image, children }) {
  return (
    <>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      {children}
    </>
  );
}

// Typechecking props for the BackgroundDesign
BackgroundDesign.propTypes = {
  // image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default BackgroundDesign;
